/* globals jQuery, google */
(($) => {

    /**
     * initialize autocomplete for address search
     */
    const input = document.getElementById("loc_address");
    const autocomplete = new google.maps.places.Autocomplete(input);

    //mobile back to map button - hide list, open map
    $('.js-map-back').on('click',function(){
        $('.section-map__list').removeClass('open');
        $('.section-map__map').addClass('open');
    });
    


    /* SETUP LOCATION MAP */
    var map = document.getElementById('location-map');
    if( map ){
        var LocationMapClass = require('./locations-map.js');
        var locationMap = new LocationMapClass(map, autocomplete);
        locationMap.initMap(true);
    }

})(jQuery)